import { connect } from "react-redux";
import DanhSachKhachHang from "components/DanhSachKhachHang";
import { getListDanhSachKhachHang } from "actions/DanhSachKhachHang";
import { getComboNguonKhachHang } from "actions/NguonKhachHang";

const mapStateToProps = (state) => ({
  danhsachkhachhang: state.danhsachkhachhang,
  nguonkhachhang:state.nguonkhachhang,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getListDanhSachKhachHang: (dataSearch) =>
    dispatch(getListDanhSachKhachHang(dataSearch)),
    getComboNguonKhachHang: (dataSearch) =>
    dispatch(getComboNguonKhachHang(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DanhSachKhachHang);
